import { createStore } from 'owa-satcheljs';
import { getIsLightRPOnFromStorage } from '../utils/localStorage';
import type LighReadingPaneStore from './schema/LightReadingPaneStore';

const initialLightRPStore: LighReadingPaneStore = {
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getIsLightRPOnFromStorage called at module scope is not allowed. This may cause unwanted side effects. */
    isLightRPOn: getIsLightRPOnFromStorage(),
};

export const getStore: () => LighReadingPaneStore = createStore<LighReadingPaneStore>(
    'lightReadingPaneStore',
    initialLightRPStore
);
